import React, { useContext, useEffect, useState } from 'react'
import { Box, Collapse, Icon } from '@deseretbook/react-ui'
import { useHistory } from 'react-router-dom'
import { InputField } from '../../dbWebUI'
import useDropdown from '../../hooks/useDropdown'
import MediaItem from './MediaItem'

import './SearchBar.css'
import { SearchContext } from './SearchProvider'

/**
 * Search Input component to search for products.
 *
 * @returns {function} Component
 */
const SearchBar = () => {
  const [inputQuery, setInputQuery] = useState('')
  const history = useHistory()
  const { results, query, setQuery, isLoading } = useContext(SearchContext)

  const isSearchPage = window.location.pathname.includes('/search')

  const dropdown = useDropdown()

  // Initialize local inputQuery with global query on mount or when URL query changes
  useEffect(() => {
    if (isSearchPage && query) {
      setInputQuery(query)
    }
  }, [isSearchPage, query])

  // Trigger dropdown when results load successfully & not on search page
  useEffect(() => {
    if (
      !isLoading &&
      !isSearchPage &&
      inputQuery.trim().length > 0 &&
      results.length > 0 &&
      inputQuery === query
    ) {
      dropdown.open()
    } else {
      dropdown.close()
    }
    // eslint-disable-next-line
  }, [isLoading, isSearchPage, inputQuery, results])

  const updateSearch = (event) => {
    const newQuery = event.target.value
    setInputQuery(newQuery)

    // Only update global query immediately if not on search page
    if (!isSearchPage) {
      setQuery(newQuery)
    }

    // Close dropdown if input cleared
    if (newQuery.trim().length === 0) {
      dropdown.close()
    }
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && inputQuery.trim().length > 0) {
      setQuery(inputQuery)
      history.push(`/search?q=${encodeURIComponent(inputQuery)}&page=1`)
      dropdown.close()
    }
  }

  const handleInputClick = () => {
    if (!isSearchPage && inputQuery.trim().length > 0 && results.length > 0) {
      dropdown.open()
    }
  }

  return (
    <Box style={{ position: 'relative' }} className="Search">
      <InputField
        {...dropdown.triggerProps}
        type="search"
        name="title"
        placeholder="What can we help you find?"
        value={inputQuery}
        onChange={updateSearch}
        onKeyPress={handleKeyPress}
        onClick={handleInputClick}
        onBlur={dropdown.close}
        fieldProps={{ isFullwidth: true }}
        style={{
          minWidth: '20rem',
          height: '3rem',
          border: '1px solid #0000001A',
          borderRadius: '1.5rem',
        }}
      />
      <Icon name="search" className="search-icon" />
      <Collapse
        {...dropdown.dropdownProps}
        isCollapsed={!dropdown.isOpen}
        style={{
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          maxHeight: '20rem',
          zIndex: 100,
          position: 'absolute',
          top: 55,
          borderRadius: '10px',
          left: 0,
        }}
      >
        <Box width={20}>
          {results.map((mediaItem) => (
            <MediaItem key={mediaItem} mediaItem={mediaItem} />
          ))}
        </Box>
      </Collapse>
      {isLoading && <Icon name="loading" isSpinning className="loading-icon" />}
    </Box>
  )
}

export default SearchBar
